import { Box, Grid } from "@mui/material"
import { DEMO_REPORTS } from "../SectionHealthReport"
import HealthReportCard from "../HealthReportCard"

const FamilyMemberNonMedicalReportsTab = () => {
  return (
    <Box
      sx={{
        my: '20px',
        mx: '2px'
      }}
    >
      <Grid container spacing='16px'>
        {DEMO_REPORTS.map((item => (
          <Grid item xs={6} mmd={3} xl={2} key={item.name}>
            <HealthReportCard data={item} />
          </Grid>
        )))}
      </Grid>
    </Box>
  )
}

export default FamilyMemberNonMedicalReportsTab